import { Check } from 'lucide-react';

import { cn } from '@/lib/shadcn/utils';

interface SavedIndicatorProps {
  isSaved: boolean;
  className?: string;
}

/**
 * The quiet "Saved" beside a setting that saves on change. The status region
 * stays mounted and only its text changes, so screen readers announce each
 * save; drive `isSaved` with `useSavedFlash`.
 */
export function SavedIndicator({ isSaved, className }: SavedIndicatorProps) {
  return (
    <span
      className={cn(
        'flex h-4 shrink-0 items-center gap-1.5 text-xs text-neutral-500',
        className,
      )}
      role="status"
    >
      {isSaved && (
        <span className="animate-in fade-in flex items-center gap-1.5 duration-200">
          <Check aria-hidden className="text-semantic-560 size-3.5" />
          Saved
        </span>
      )}
    </span>
  );
}
